exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n[data-v-48c67c91] .el-form-item {\n  margin-bottom: 4px;\n}\n.schannel-wrap[data-v-48c67c91] {\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-pack: justify;\n      -ms-flex-pack: justify;\n          justify-content: space-between;\n  -webkit-box-align: center;\n      -ms-flex-align: center;\n          align-items: center;\n}\n.schannel-wrap .el-dropdown-link[data-v-48c67c91] {\n  cursor: pointer;\n  padding-right: 10px;\n}\n", ""]);

// exports
